import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ascent",
  "use": "icon-ascent-usage",
  "viewBox": "0 0 20 12",
  "content": "<symbol viewBox=\"0 0 20 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ascent\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-2-6h24v24H-2z\" /><path fill=\"#55D187\" fill-rule=\"nonzero\" d=\"M14 0l2.29 2.29-4.88 4.88-4-4L0 10.59 1.41 12l6-6 4 4 6.3-6.29L20 6V0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol